import request from "@/utils/request"

// 新增商家产品模板
export function addTemplate(data) {
  return request({
    url: "/server/template/add",
    method: "post",
    data: data,
  })
}

// 查询商家产品模板列表
export function getTemplateList(data) {
  return request({
    url: "/server/template/list",
    method: "get",
    params: data,
  })
}

// 删除商家产品模板
export function delTemplate(data) {
  return request({
    url: "/server/template/delete/" + data,
    method: "post",
  })
}

// 获取商家产品模板详细信息 用于查看详情
export function getTemplateInfo(data) {
  return request({
    url: "/server/template/getInfo/" + data,
    method: "get",
  })
}

export function getRemitList(data) {
  return request({
    url: "/server/remit/list",
    method: "get",
    params: data
  })
}

export function getVarList(data) {
  return request({
    url: "/server/var/list",
    method: "get",
    params: data
  })
}

export function listDesignColorsize(data) {
  return request({
    url: "/server/remit/listDesignColorsize",
    method: "get",
    params: data
  })
}

export function listAmazonColorsize(data) {
  return request({
    url: "/server/remit/listAmazonColorsize",
    method: "get",
    params: data
  })
}







export function getVarListDesign(data) {
  return request({
    url: "/server/var/listDesign",
    method: "get",
    params: data
  })
}




export function getSkuList(data) {
  return request({
    url: "/server/remit/listSku",
    method: "get",
    params: data
  })
}


export function listRemitSkuByDesignId(data) {
  return request({
    url: "/server/remit/listRemitSkuByDesignId",
    method: "get",
    params: data
  })
}



export function getVarListColl(data) {
  return request({
    url: "/server/var/listColl",
    method: "get",
    params: data
  })
}



export function addRemit(data) {
  return request({
    url: "/server/remit/add",
    method: "post",
    data: data
  })
}

export function addAmazonRemit(data) {
  return request({
    url: "/server/amazon/product/addRemit",
    method: "post",
    data: data
  })
}
export function addTemplateRemit(data) {
  return request({
    url: "/server/universal/template/addTemplateRemit",
    method: "post",
    data: data
  })
}
export function deleteTemplateRemit(data) {
  return request({
    url: "/server/universal/template/deleteTemplateRemit",
    method: "post",
    data: data,
    params: data
  })
}

export function deleteTemplateRemits(data) {
  return request({
    url: "/server/universal/template/deleteTemplateRemits",
    method: "post",
    data: data,
    params: data
  })
}

export function getRemitInfo(remitId) {
  return request({
    url: "/server/universal/template/getRemitInfo/" + remitId,
    method: "get",
  })
}

